import { ITrainingRole } from 'graphql/types';

// Roles rendered as chips, in display order.
// Only added roles are surfaced.
const ROLE_LABEL_KEYS = [
    [ITrainingRole.Trainer, 'trainer'],
    [ITrainingRole.Mentor, 'mentor'],
    [ITrainingRole.Groupmanager, 'groupmanager'],
    [ITrainingRole.Participant, 'participant'],
] as const;

export interface IVisibleTrainingRole {
    role: ITrainingRole;
    labelKey: string;
}

// Resolves which training role chips should actually render.
export const getVisibleTrainingRoles = (
    roles?: ITrainingRole[] | null,
    hiddenRoles?: ITrainingRole[]
): IVisibleTrainingRole[] => {
    if (!roles?.length) return [];

    const isGroupmanager = roles.includes(ITrainingRole.Groupmanager);

    return ROLE_LABEL_KEYS.filter(([role]) => {
        if (!roles.includes(role) || hiddenRoles?.includes(role)) return false;

        // The participant role is only surfaced when the user is also a
        // groupmanager.
        if (role === ITrainingRole.Participant) return isGroupmanager;

        return true;
    }).map(([role, labelKey]) => ({ role, labelKey }));
};
